import { scpmUtil } from '@/utils/scpmUtil';
import moment from 'moment-timezone';

export default {
  isEmpty(str) {
    return str === null || str === undefined || str === '';
  },

  removeTrailingSlash(url) {
    if (url && url.trim().length > 0) {
      return url.slice(-1) === '/' ? url.slice(0, -1) : url;
    }

    return '';
  },

  async setSessionStorageData(sessionInfo) {
    window.sessionStorage.setItem('userUuid', sessionInfo.uuid);
    await this.setLanguage(sessionInfo.language);
  },

  setWindowLocation(url) {
    const validProtocols = ['http:', 'https:']
    try {
      const urlInstance = new URL(url)
      if (validProtocols.includes(urlInstance.protocol)) {
        window.location.href = urlInstance.href;
      } else {
        console.error('Invalid protocol in URL.')
      }
    } catch (error) {
      console.error('Invalid URL provided:', error)
    }
  },

  async setLanguage(language) {
    let convertLanguage = language;
    if (this.isEmpty(language)) {
      convertLanguage =
        window.localStorage.getItem('language') || navigator.language || navigator.userLanguage;
    }
    if (convertLanguage === 'ko-KR') {
      await localStorage.setItem('language', 'ko_KR');
    } else if (convertLanguage === 'en-US') {
      await localStorage.setItem('language', 'en_US');
    } else {
      await localStorage.setItem('language', convertLanguage);
    }
  },

  getLanguageTag(info) {
    const languageTags = {
      ko: 'ko_KR',
      en: 'en_US'
    };
    const language = localStorage.getItem('language') || 'ko';
    let languageTag = languageTags[language];
    if (info && info.languageTag) {
      languageTag = info.languageTag;
    }
    return languageTag;
  },

  getLocale() {
    return (
      window.localStorage.getItem('language') ||
      navigator.language ||
      navigator.userLanguage
    ).substring(0, 2);
  },

  equalsIgnoreOrder(a, b) {
    if (a.length !== b.length) return false;
    const uniqueValues = new Set([...a, ...b]);
    for (const v of uniqueValues) {
      const aCount = a.filter((e) => e === v).length;
      const bCount = b.filter((e) => e === v).length;
      if (aCount !== bCount) return false;
    }
    return true;
  },

  customSort(items, sortKey, sortDirection) {
    return scpmUtil.customSort(items, sortKey, sortDirection)
  },
  getAccountId() {
    return scpmUtil.getAccountId();
  },

  setDefaultTimezone(timezoneId) {
    if (timezoneId) moment.tz.setDefault(timezoneId);
  },

  setCurrentUserInfo(userInfo) {
    const { timezone, utc_offset, user_name, email, id, login_id, account_id, tz_id } = userInfo;
    window.sessionStorage.setItem('timeZoneInfo', timezone);
    window.sessionStorage.setItem('timezoneUtcOffset', utc_offset);
    window.sessionStorage.setItem('userId', id);
    window.sessionStorage.setItem('userName', user_name);
    window.sessionStorage.setItem('loginId', login_id);
    window.sessionStorage.setItem('userEmail', email);
    window.sessionStorage.setItem('accountId', account_id);
    this.setDefaultTimezone(tz_id);
  },

  getUserUuid() {
    if (process.env.NODE_ENV === 'test') return window.localStorage.getItem('userUuid') || '';
    return window.sessionStorage.getItem('userUuid') || '';
  }
};
